import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500" style={{ width: '20px', height: '20px' }}></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">
                韩漫在线观看
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              提供最优质的韩漫在线观看体验，免费漫画下拉式阅读，海量韩漫资源每日更新，让您随时随地畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {categories.filter((c) => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-foreground-500" style={{ width: '16px', height: '16px' }}></i>
                </div>
                <span>contact@hanmancomic.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-2-line text-foreground-500" style={{ width: '16px', height: '16px' }}></i>
                </div>
                <span>7×24小时在线客服</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-shield-check-line text-foreground-500" style={{ width: '16px', height: '16px' }}></i>
                </div>
                <span>安全稳定 · 绿色阅读</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫在线观看 - 版权所有。本站所有漫画资源均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}